import {
    Directive,
    Output,
    EventEmitter,
    HostListener,
    ElementRef
} from "@angular/core";

@Directive({
    selector: "[clickOutside]"
})
export class ClickOutsideDirective {
    /**
     * Output  of click outside directive
     */
    @Output("clickOutside") clickOutside: EventEmitter<any> = new EventEmitter();
    /**
     * Creates an instance of click outside directive.
     * @param elementRef ElementRef
     */
    constructor(private elementRef: ElementRef) {}
    /**
     * Hosts listener
     * @param targetElement any
     */
    @HostListener("document:click", ["$event.target"])
    onMouseEnter(targetElement: any) {
        const clickedInside = this.elementRef.nativeElement.contains(
            targetElement
        );
        if (!clickedInside) {
            this.clickOutside.emit(targetElement);
        }
    }
}
